import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { AdminLayout } from "./layout/AdminLayout";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { VerificationOrganizersPage } from "./pages/VerificationOrganizersPage";
import { VerificationSuppliersPage } from "./pages/VerificationSuppliersPage";
import { CreateModeratorPage } from "./pages/CreateModeratorPage";
import { StatsPage } from "./pages/StatsPage";

export const App = () => (
  <AuthProvider>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="verification/organizers" element={<VerificationOrganizersPage />} />
        <Route path="verification/suppliers" element={<VerificationSuppliersPage />} />
        <Route path="moderators" element={<CreateModeratorPage />} />
        <Route path="moderators/new" element={<CreateModeratorPage />} />
        <Route path="stats" element={<StatsPage />} />
      </Route>
    </Routes>
  </AuthProvider>
);
